import { render, staticRenderFns } from "./LerNaoLer.vue?vue&type=template&id=d4004cde"
import script from "./LerNaoLer.vue?vue&type=script&lang=js"
export * from "./LerNaoLer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports